import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
// Components
import Modal from '@/components/base/Modal';

const RefreshConfirmationModal = ({ isOpen, toggle, onConfirm, isLoading }) => {
    const { t } = useTranslation('commons');

    return (
        <Modal open={isOpen} onDismiss={toggle}>
            <Modal.Body>
                <Modal.Title>{t('scheduler:collaboration.settings.refresh_title')}</Modal.Title>
                <Modal.Content className="pt-8 text-center text-sm">
                    {t('scheduler:collaboration.settings.refresh_notice')}
                </Modal.Content>
            </Modal.Body>
            <Modal.Footer className="my-8 flex justify-center space-x-6">
                <Button onClick={onConfirm} isLoading={isLoading}>
                    {t('update')}
                </Button>
                <Button variant="secondary" onClick={toggle}>
                    {t('cancel')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RefreshConfirmationModal;
